// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M6.19787 0.515433L0.498877 0.512695L0.497514 2.51269L2.36967 2.51397C-0.789628 6.98854 -0.78989 13.0115 2.36888 17.4863L0.497831 17.4866L0.498152 19.4866L6.19787 19.486L6.19787 14.5007H4.19787L4.19787 16.6002C1.26738 12.7018 1.26738 7.2996 4.19787 3.40123L4.19787 5.50071L6.19787 5.50071L6.19787 0.515433Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M7.97413 5.63763C6.89318 6.26172 6.52283 7.64391 7.14691 8.72485L11.1787 15.7082L8.59641 16.5885C7.87729 16.8337 7.37667 17.4879 7.32799 18.2461L7.21825 19.9551L13.7363 22.6481C14.5276 22.975 15.4259 22.9158 16.1674 22.4877L22.3036 18.9449C23.3314 18.3515 23.8641 17.167 23.6259 16.0043L22.4943 10.4794C22.2325 9.20158 21.111 8.28206 19.8067 8.27588L15.6098 8.25597C15.1214 8.25365 14.6412 8.3811 14.2183 8.62527L12.7861 9.45217L11.0613 6.46485C10.4373 5.38391 9.05507 5.01355 7.97413 5.63763Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-gesture-up-and-down-filled')
export default class GestureUpAndDownFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'gesture-up-and-down-filled',
    }
  }
}
